import { createAsyncReducer, createReducerFromMap } from "@coverme/redux";

const initialState = {
    isLoading: false,
    isInitialized: false,
    data: [],
};

export const pdfForCustomerReducer = createReducerFromMap(initialState, {
    ...createAsyncReducer("GET_PDF_LIST_FOR_CUST_CODE", (state, action) => {
        return action.value;
    }),
});
